import * as aboutBuild_File from '../../about_build.json'; // generated in CI/CD pipeline; see build.yml

const aboutBuild = aboutBuild_File;

export const version = {
    appVersion: '3.17.2',
    buildDate: '2025-7-10 8:35:40',
    pipelineDate: aboutBuild.time !== 0 ? new Date(aboutBuild.time).toISOString() : 'local-build-no-date-available',
    mivbComponentsVersion: aboutBuild['mivbComponentsVersion'],
    headerVersion: aboutBuild['headerVersion'],
    cloudlinkVersion: aboutBuild['cloudlinkVersion'],
    commit: aboutBuild['commit'],
}